<template>
  <BaseDialog
    :title="quarterTitle"
    :dialog="dialog"
    :is-show-mode="isShowMode"
    :is-edit="isEdit"
    :is-invalid="$v.$invalid || !dataLoaded"
    :save-btn-loading="saveBtnLoading"
    @close="closeModal"
    @save="savePeriod"
  >
    <div
      class="text-center"
      v-if="!dataLoaded"
    >
      <v-progress-circular
        class="mt-6 mb-6"
        color="primary"
        indeterminate
        :size="50"
      />
    </div>

    <template v-else>
      <UIDatePickerMenu
        v-model="period.fromDate"
        label="Дата начала"
        :disabled="true"
      />

      <UIDatePickerMenu
        v-model="period.blockDate"
        class="mt-2"
        :errorMessages="errorMessages.blockDate"
        label="Дата блокировки"
        @input="$v.period.blockDate.$touch(), $v.period.toDate.$touch()"
      />

      <UIDatePickerMenu
        v-model="period.toDate"
        class="mt-2"
        :errorMessages="errorMessages.toDate"
        label="Дата окончания"
        @input="$v.period.toDate.$touch(), $v.period.blockDate.$touch()"
      />
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '../../../ui/BaseDialog'
import { required } from 'vuelidate/lib/validators'
import { checkPeriodBlockAndToDate, setValidateMessages } from '@/scripts/validation'
import UIDatePickerMenu from '@/components/ui/UIDatePickerMenu.vue'
import { Period } from '@/models/directories/Period'

export default {
  components: { UIDatePickerMenu, BaseDialog },
  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    dialog: Boolean,
    selectedItem: Object
  },

  data: () => ({
    period: new Period(),
    dataLoaded: false,
    isFirstGroupClose: true
  }),

  validations() {
    return {
      period: {
        fromDate: { required },
        blockDate: { required, checkPeriodBlockAndToDate },
        toDate: { required, checkPeriodBlockAndToDate }
      }
    }
  },

  computed: {
    isEdit() {
      return !!this.selectedItem?.id
    },

    quarterTitle() {
      return this.period.quarter && this.period.year
        ? `${this.period.quarter.name} ${this.period.year.year} года`
        : 'Квартал'
    },

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.period.$params).forEach(key => {
        allErrors[key] = setValidateMessages(this.$v.period[key])
      })

      return allErrors
    }
  },

  methods: {
    async getData() {
      this.dataLoaded = true
    },

    savePeriod() {
      this.$emit('savePeriod', this.period)
    },

    closeGroupOnce(toggleFunction) {
      if (this.isFirstGroupClose) {
        toggleFunction()
      }
    },

    resetModal() {
      this.$v.$reset()
      this.period = new Period()
    },

    closeModal() {
      this.resetModal()
      this.$emit('closeModal')
    }
  },

  watch: {
    selectedItem(val) {
      this.period = val ? new Period(val) : new Period()
    },

    dialog(val) {
      if (val) {
        this.getData()
      } else {
        this.resetModal()
      }
    }
  }
}
</script>
